// extracted by mini-css-extract-plugin
export default {"categoriesNav":"CategoriesNav_categoriesNav__dNlpU","catButton":"CategoriesNav_catButton__9Buu6"};